import { DESKTOP_SMALL_BREAKPOINT, TABLET_BREAKPOINT } from '@maverick/utils';
import styled from 'styled-components';

export const Container = styled.div`
	background-color: #38322c;
	height: 100%;
	padding: 60px 80px;

	input {
		border-bottom-width: 3px;
		border-bottom-color: #38322C;
	}

	@media screen and (max-width: ${DESKTOP_SMALL_BREAKPOINT}px) {
		padding: 40px;
	}

	@media screen and (max-width: ${TABLET_BREAKPOINT}px) {
		padding: 24px;
	}
`;

export const Header = styled.div`
	display: flex;
	color: #ffffff !important;
	font-family: 'Geomanist-bold', sans-serif;
	margin-bottom: 48px;
`;

export const HeaderMobile = styled.div`
	color: #ffffff !important;
	font-family: 'Geomanist-bold', sans-serif;
	margin-bottom: 48px;
`;

export const MobileHeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 40px;
`;

export const LogoutContainer = styled.div`
	width: 20%;
	text-align: left;
`;

export const Logout = styled.a`
	cursor: pointer;
	text-decoration: underline;
	font-size: 16px;
	line-height: 21.67px;
	color: #ffffff;
`;

export const Title = styled.div`
	display: flex;
	justify-content: center;
	text-align: center;
	width: 60%;

	@media screen and (max-width: ${TABLET_BREAKPOINT}px) {
		width: 100%;
	}
`;

export const HeaderTitle = styled.div`
	font-size: 24px;
	line-height: 32.51px;
	text-align: center;
`;

export const EditProfileButton = styled.div`
	cursor: pointer;
	text-decoration: underline;
	font-size: 16px;
	line-height: 21.67px;
	margin: auto 0px;
	margin-left: 24px;
	height: 24px;
	display: flex;
	gap: 4px;
`;

export const HeaderClose = styled.div`
	font-size: 16px;
	line-height: 21.67px;
	width: 20%;
	text-align: right;
`;

export const IconContainer = styled.div`
	cursor: pointer;
	float: right;
	width: 30px;
	height: 30px;
`;

export const Content = styled.div`
	color: #ededed !important;
	font-family: 'Geomanist-bold', sans-serif;
	font-size: 16px;
	margin: auto;
	max-width: 800px;
	width: 55%;

	@media screen and (max-width: ${DESKTOP_SMALL_BREAKPOINT}px) {
		padding: 0px;
		width: unset;
	}
`;

export const SectionInfo = styled.div`
	margin-bottom: 32px;
`;

export const SectionTitle = styled.div`
	text-align: center;
`;

export const NameInput = styled.div`
	align-items: end;
	display: flex;
	gap: 16px;
`;

export const NameContainer = styled.div`
	position: relative;
`;

export const InputContainer = styled.div`
	margin-top: 16px;
	flex: 1;
	position: relative;
	font-size: 14px;
	font-weight: 400;
	line-height: 17px;
	font-family: 'Open sans', sans-serif;
`;

export const TooltipContainer = styled.div`
	position: absolute;
	width: 16px;
	height: 16px;
	bottom: 18px;
	right: 16px;
	color: #8a8a8a;
`;

export const FormButtonContainer = styled.div`
	display: flex;
	gap: 40px;
	justify-content: space-between;
	margin-top: 32px;

	@media screen and (max-width: ${TABLET_BREAKPOINT}px) {
		flex-direction: column;
		gap: 24px;
	}
`;

export const SaveButton = styled.button`
	width: 50%;
	margin: auto 0px;
	text-align: center;
	padding: 16px;
	border: none;
	background-color: #ab6503;
	font-family: 'Geomanist-bold', sans-serif;
	font-size: 14px;
	line-height: 17px;
	color: #fff;

	&:hover {
		filter: brightness(95%);
		cursor: pointer;
	}

	@media screen and (max-width: ${TABLET_BREAKPOINT}px) {
		width: 100%;
	}
`;

export const ExitButton = styled.button`
	width: auto;
	padding: 0px;
	margin: auto;
	text-align: center;
	border: none;
	background-color: unset;
	font-family: 'Geomanist-bold', sans-serif;
	font-size: 14px;
	line-height: 17px;

	color: #fff;
	&:hover {
		filter: brightness(95%);
		cursor: pointer;
	}

	@media screen and (max-width: ${TABLET_BREAKPOINT}px) {
		width: 100%;
		padding: 16px;
	}
`;

export const BackButton = styled.div`
	width: 24px;
	height: 24px;
	cursor: pointer;
`;

export const EditIcon = styled.div`
	width: 20px;
	height: 20px;
`;

export const DropdownLabel = styled.div`
	margin-bottom: 8px;
`;

export const ErrorMessageContainer = styled.div<{ field?: string }>`
	margin-top: 4px;
	font-weight: 700;
	font-size: 12px;
	font-family: 'Open sans', sans-serif;

	@media screen and (min-width: ${DESKTOP_SMALL_BREAKPOINT + 1}px) {
		position: absolute;
		left: 100%;
		transform: translateY(-50%);
		width: 200px;
		padding-left: 32px;
		margin-top: 0px;

		${({ field }) => {
			if (field == 'name') {
				return `
					top: calc(60% + 10px);
				`;
			} else {
				return `
					top: calc(50% + 10px)
				`;
			}
		}}
	}
`;

export const SavedChangesMessage = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: 'Geomanist-bold', sans-serif;
	font-size: 14px;
	line-height: 33px;
	letter-spacing: 2px;
	text-align: center;
`;

export const PasswordRules = styled.div`
	margin-top: 4px;
	font-weight: 700;
	font-size: 12px;

	@media screen and (min-width: ${DESKTOP_SMALL_BREAKPOINT + 1}px) {
		position: relative;
		left: 100%;
		transform: translateY(-55px);
		width: 50%;
		min-width: 200px;
		padding-left: 32px;
		height: 65px;
		margin-top: 0px;
	}
`;

export const PasswordRuleRow = styled.div``;
